import { ClassRef, InterfaceRef } from "@baseline/common/types";
import { Context, ContextRef } from "./context";
import { Registry } from "./registry";
import { ServiceProvider } from "./service";


export interface Require
{
    <T>(serviceType: ClassRef<T>): T;
    <T>(serviceType: InterfaceRef<T>): T;
}


export namespace Require
{
    export function make(contextRef: ContextRef, options?: RequireOptions): Require
    {
        const registry = options?.registry ?? Registry.create();
        const provider = options?.provider ?? ServiceProvider.defaultProvider;

        const context = contextRef as Context;

        const require: Require =
            <T>(serviceType: ClassRef<T> | InterfaceRef<T>) =>
            {
                let service = registry.get(serviceType);

                if (!service)
                {
                    service = provider(serviceType, context);
                    registry.set(serviceType, service);
                }

                return service;
            };

        return require;
    }
}


export interface RequireOptions
{
    registry?: Registry;
    provider?: ServiceProvider;
}


export interface Entry<T = any>
{
    service: T;
    init?: T | Promise<T>;
}
